/**
 * Pill chip rendering a photo capture session's export status —
 * capturing | uploading | ready | pushed | failed. Color comes from
 * the audit-table tab palette so the visual signal matches the
 * surrounding INVI surfaces. Used on Image Index rows and on the
 * Vehicle Detail page metadata block.
 */
import React from "react"

import { THEME } from "../../config/theme"
import { tint } from "../../utils/color"

interface Props {
  status: string | null | undefined
}

export default function ExportStatusChip({ status }: Props) {
  if (!status) return <span style={mutedStyle}>—</span>
  const accent = accentFor(status)
  return <span style={chipStyle(accent)}>{status}</span>
}

function accentFor(status: string): string {
  switch (status) {
    case "pushed":
      return THEME.auditTable.tabColors.completed
    case "ready":
      return THEME.auditTable.tabColors.pending
    case "failed":
      return THEME.auditTable.tabColors.discrepancies
    // capturing / uploading
    default:
      return THEME.auditTable.tabColors.unclassified
  }
}

const chipStyle = (accent: string): React.CSSProperties => ({
  display: "inline-block",
  padding: "2px 8px",
  fontSize: 11,
  fontWeight: 500,
  borderRadius: 999,
  background: tint(accent, 0.5),
  color: THEME.colors.neutral.light.textPrimary,
  border: `1px solid ${accent}`,
  textTransform: "lowercase",
})

const mutedStyle: React.CSSProperties = {
  fontSize: 13,
  color: THEME.colors.neutral.light.textSecondary,
}
